import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

import '../../scss/brand.scss';
import CustomRangeInput from '../../../../shared-components/custom-range-input/custom-range-input';
import CustomSwitchButton from '../../../../shared-components/custom-switch-button/custom-switch-button';

/**
 * QR Brand Component
 * @param {any} param0 - The param0
 * @param {any} param0.qrValues - The qrValues prop
 * @param {any} param0.setQrValues - The setQrValues prop
 * @returns {any} The result
 */
function Brand({ qrValues, setQrValues }: any) {
  const { t } = useTranslation('qrCode');
  const [checkedTrue, setCheckedTrue] = useState<boolean>(false);

  const logoProperties = [
    {
      id: 1,
      name: 'logoWidth',
      value: qrValues.logoWidth,
      label: t('logoSize'),
      min: 50,
      max: 150,
      valueType: 'Px',
    },
    {
      id: 2,
      name: 'logoTrans',
      value: qrValues.logoTrans,
      label: t('logoTranspatency'),
      min: 0.0,
      max: 1.0,
      step: 0.1,
      valueType: '%',
    },
  ];

  /**
   * Handling Range Values
   * @param {any} name - The name
   * @param {any} value - The value
   */
  const handleValue = (name: string, value: string | number) => {
    setQrValues((previous: any) => ({
      ...previous,
      [name]: value,
    }));
  };

  /**
   * Handling Switch Enabling
   */
  const handleSwitch = () => {
    if (checkedTrue === false) {
      setCheckedTrue(true);
    } else {
      setCheckedTrue(false);
    }
  };

  return (
    <div className="brand">
      <div className="brand-logo">
        {logoProperties.map((Property) => (
          <CustomRangeInput
            key={Property.id}
            label={Property.label}
            name={Property.name}
            value={Property.value}
            valueType={Property.valueType}
            onChange={handleValue}
            min={Property.min}
            max={Property.max}
            step={Property.step}
          />
        ))}
      </div>
      <div className="brand-logo-bg">
        <div>
          <p className="switch-button">{t('backgroundColor')} </p>
          <CustomSwitchButton checked={checkedTrue} change={handleSwitch} />
        </div>
        <input type="color" />
      </div>
    </div>
  );
}

export default Brand;
